"use client";

import React from 'react';

export type CollapseContextType = {
  isShowing: boolean;
  id: string;
  monitorHeight: boolean;
  intentToAnimate: boolean;
  bindTrigger: {
    onMouseEnter: () => void;
    onMouseLeave: () => void;
    onClick: () => void;
    'aria-controls': string;
    'aria-expanded': boolean;
  };
  bindCollapse: {
    id: string;
  };
};

export const CollapseContext = React.createContext<CollapseContextType>({
  isShowing: false,
  id: '',
  monitorHeight: false,
  intentToAnimate: false,
  bindTrigger: {
    onMouseEnter: () => {},
    onMouseLeave: () => {},
    onClick: () => {},
    'aria-controls': '',
    'aria-expanded': false,
  },
  bindCollapse: {
    id: '',
  },
});
